package org.chiangmeng.qfast.core.ui.staff

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.chiangmeng.qfast.core.ui.theme.QFastTheme
import org.chiangmeng.qfast.features.auth.AuthScreen

data class StaffScreen(val shopId: String) : Screen {
    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<StaffViewModel>()
        val state by viewModel.state.collectAsState()
        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(shopId) {
            viewModel.handleIntent(StaffContract.Intent.LoadData(shopId))
        }

        QFastTheme(appTheme = state.currentTheme) {
            Box(modifier = Modifier.fillMaxSize()) {
                StaffDashboardScreen(
                    state = state,
                    onIntent = { intent -> viewModel.handleIntent(intent) }
                )

                if (state.isForceLoggedOut) {
                    println("QFAST_LOCK_LOG: [6. UI Dialog Display] -> Rendering AlertDialog for Force Logout")
                    AlertDialog(
                        onDismissRequest = {},
                        title = { Text("การแจ้งเตือนเซสชัน") },
                        text = { Text("มีการเข้าสู่ระบบร้านค้านี้จากอุปกรณ์อื่น บัญชีนี้ถูกออกจากระบบเพื่อความปลอดภัย") },
                        confirmButton = {
                            TextButton(onClick = {
                                viewModel.handleIntent(StaffContract.Intent.SignOut {
                                    navigator.replaceAll(AuthScreen())
                                })
                            }) {
                                Text("ตกลง")
                            }
                        }
                    )
                }
            }
        }
    }
}
